import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/ui/Header";
import ServiceHero from "./components/ServiceHero";
import ServiceJourney from "./components/ServiceJourney";
import ServiceCTA from "./components/ServiceCTA";
import LogoSolarValley from "../../components/img/SolarValley.svg";
import {
  useConfig
} from "../../context/ConfigContext";

const ServicesOverview = () => {
  const config = useConfig();
  const {
    COMPANY_NAME,
    PHONE_NUMBER_FORM,
    EMAIL_ADDRESS
  } = config;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Servicios Integrales de Energía Solar | {COMPANY_NAME} Guatemala
        </title>
        <meta
          name="description"
          content="Servicios completos de energía solar en Guatemala: consulta, diseño, instalación, mantenimiento y soporte 24/7. Garantías extendidas y financiamiento disponible."
        />
        <meta
          name="keywords"
          content="Limpieza Solar, Termografía Solar, mantenimiento paneles solares Guatemala, instalación paneles solares, garantía solar, Solar Valley"
        />
        <link rel="canonical" href="https://www.solarvalleygt.com/servicios" />
        <meta
          property="og:title"
          content={`Servicios de Energía Solar | Limpieza y Termografía | ${COMPANY_NAME} Guatemala`}
        />
        <meta
          property="og:description"
          content="Optimiza tu planta solar con nuestros servicios de Limpieza Solar Profesional y Termografía con Drones. Expertos en mantenimiento en toda Guatemala."
        />
        <meta property="og:image" content="/og-image.png" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        <main>
          <ServiceHero />
          <ServiceJourney />
          <ServiceCTA />
        </main>

        <footer className="bg-text-primary text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div>
                <div className="flex items-center space-x-3 mb-4">
                  <img src={LogoSolarValley} alt="Logo" width="100" />
                  <div>
                    <h3 className="text-lg font-bold">{COMPANY_NAME}</h3>
                    <p className="text-sm text-gray-300">
                      Energía Limpia Guatemala
                    </p>
                  </div>
                </div>
                <p className="text-gray-300 text-sm">
                  Líderes en soluciones de energía solar para hogares y empresas
                  en Guatemala.
                </p>
              </div>

              <div>
                <h4 className="font-semibold mb-4">Servicios</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li>Sistemas Residenciales</li>
                  <li>Proyectos Comerciales</li>
                  <li>Mantenimiento</li>
                  <li>Monitoreo 24/7</li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold mb-4">Contacto</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li>{PHONE_NUMBER_FORM}</li>
                  <li>{EMAIL_ADDRESS}</li>
                  {/*<li>Zona 10, Guatemala</li>
                  <li>Lun-Vie 8:00-18:00</li>*/}
                </ul>
              </div>

              {/*<div>
                <h4 className="font-semibold mb-4">Síguenos</h4>
                <div className="flex space-x-4">
                  <a href="#" className="text-gray-300 hover:text-primary">
                    Facebook
                  </a>
                  <a href="#" className="text-gray-300 hover:text-primary">
                    Instagram
                  </a>
                  <a href="#" className="text-gray-300 hover:text-primary">
                    LinkedIn
                  </a>
                </div>
              </div>*/}
            </div>

            <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-300">
              <p>
                &copy; {new Date()?.getFullYear()} {COMPANY_NAME} Guatemala.
                Todos los derechos reservados.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ServicesOverview;
